import 'setup/initialize-sentry';
import { PageErrorBoundary } from 'components/error-boundary';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import SignupRoute from 'routes/signup/SignupRoute';
import { ThemeProvider } from 'utils/theme';

createRoot(document.getElementById('signup-app')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <PageErrorBoundary>
          <SignupRoute />
        </PageErrorBoundary>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
